"use client";

import { useEffect, useRef, useState } from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "Exceptional service! The driver was punctual, professional, and the vehicle was immaculate. Made our airport transfer stress-free.",
  author: "Sarah Mitchell",
  role: "Business Executive"
}, {
  id: 2,
  quote: "I've used Car Service Connecticut multiple times for corporate travel. Always reliable, always comfortable. Highly recommend!",
  author: "James Rodriguez",
  role: "Corporate Manager"
}, {
  id: 3,
  quote: "The luxury SUV was perfect for our family trip to JFK. Smooth ride, courteous driver, and competitive pricing.",
  author: "Emily Chen",
  role: "Travel Enthusiast"
}, {
  id: 4,
  quote: "Best car service in Connecticut! Used them for a night out in NYC and the experience was flawless from start to finish.",
  author: "Michael Thompson",
  role: "Event Coordinator"
}, {
  id: 5,
  quote: "Professional, punctual, and premium service. The attention to detail and customer care is outstanding.",
  author: "Jennifer Martinez",
  role: "Consultant"
}, {
  id: 6,
  quote: "Reliable 24/7 service that I can count on for all my airport transfers. The luxury sedans are top-notch!",
  author: "David Park",
  role: "Frequent Traveler"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const scrollerContent = scroller.querySelector('[data-scroller-content]');
    if (!scrollerContent) return;
    const items = Array.from(scrollerContent.children);
    items.forEach(item => {
      const clone = item.cloneNode(true) as HTMLElement;
      scrollerContent.appendChild(clone);
    });
    let animationId: number;
    let scrollPos = 0;
    const speed = 0.5;
    function animate() {
      if (!isPaused && scroller && scrollerContent) {
        scrollPos += speed;
        const maxScroll = scrollerContent.scrollWidth / 2;
        if (scrollPos >= maxScroll) {
          scrollPos = 0;
        }
        scroller.scrollLeft = scrollPos;
      }
      animationId = requestAnimationFrame(animate);
    }
    animationId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [isPaused]);
  return <section ref={ref} className="bg-secondary py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-6 mb-12">
        <h2 className={`text-3xl md:text-4xl font-display font-bold text-center text-black transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          What Our Clients Say
        </h2>
        <p className={`text-black/70 text-center mt-4 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Trusted by professionals and travelers across Connecticut and beyond
        </p>
      </div>

      <div ref={scrollerRef} className="overflow-x-hidden w-full" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
        <div data-scroller-content className="flex gap-6 w-max" style={{
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem"
      }}>
          {testimonials.map((testimonial, i) => <div key={testimonial.id} data-index={i} className={`card w-[350px] md:w-[400px] flex-shrink-0 p-6 bg-background border border-muted/20 shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] group ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
          transitionDelay: `${Math.min(i * 100, 500)}ms`
        }}>
              <Quote className="text-accent mb-4 transition-transform duration-[var(--duration-medium)] group-hover:animate-wiggle" size={32} />
              <blockquote className="text-black text-base leading-relaxed mb-6">
                "{testimonial.quote}"
              </blockquote>
              <div className="border-t border-muted/20 pt-4">
                <p className="font-semibold text-black">{testimonial.author}</p>
                <p className="text-sm text-black/70">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>

      <style jsx>{`
        @keyframes wiggle {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-5deg); }
          75% { transform: rotate(5deg); }
        }
        .group:hover .animate-wiggle {
          animation: wiggle 0.5s ease-in-out;
        }
      `}</style>
    </section>;
}